import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IAppAlertApiListResponse, IAppAlertDataResponse, IAppAlertDeleteParams, IAppAlertUpdateParams } from '@/types/appAlert';

export const appAlertList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IAppAlertApiListResponse>> => {
    return axios.get('/api/appalert/list', { ...config, params });
};

export const appAlertUpdate = (params: IAppAlertUpdateParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/appalert/update', params);
};

export const appAlertDelete = (params: IAppAlertDeleteParams): Promise<AxiosResponse<{ success: boolean }>> => {
    return axios.post('/api/appalert/delete', params);
};

export const appAlertData = (params: { data_id: number }): Promise<AxiosResponse<IAppAlertDataResponse>> => {
    return axios.get('/api/appalert/data', { params: { ...params, _dc: Date.now() } });
};
